import React from "react";
import { useTranslation } from "react-i18next";

import { InstagramData } from "../../../../utils/getInstagramStatus";

import "./styles.scss";

export interface IErrorInstructionsProps {
  instagramData: InstagramData;
}

export const InstagramErrorInstructions: React.FunctionComponent<
  IErrorInstructionsProps
> = (props) => {
  const { instagramData } = props;

  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`facilityDetailsPage.externalIntegrations.${key}`);

  if (instagramData.status === "insufficient_permissions") {
    return (
      <p
        className="instagram-error-instructions"
        dangerouslySetInnerHTML={{
          __html: t("instagram_insufficient_permissions_instructions"),
        }}
      />
    );
  }

  if (instagramData.status === "invalid") {
    return (
      <p
        className="instagram-error-instructions"
        dangerouslySetInnerHTML={{
          __html: t("instagram_invalid_instructions"),
        }}
      />
    );
  }

  return null;
};
